import { Currency } from '@/core/currency/interfaces';

const MRU: Currency = {
    name: 'Mauritanian Ouguiya',
    demonym: 'Mauritanian',
    majorSingle: 'Ouguiya',
    majorPlural: 'Ouguiya',
    codeNumeric: '929',
    symbol: 'UM',
    symbolNative: 'أ.م.',
    minorSingle: 'Khoums',
    minorPlural: 'Khoums',
    ISOdigits: 2,
    decimals: 0,
    numToBasic: 5,
    code: 'MRU',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default MRU;
